export function headerFunc() {
  toggleMenu()
}

/**
 * ハンバーガーメニュー
 */
function toggleMenu() {
  const toggleButton = document.querySelector('.js-header-toggle-button');
  const menu = document.querySelector('.js-header-sp-menu');

  toggleButton.addEventListener('click', function() {
    toggleMenuState();
  });

  // メニュー内のリンクにイベントリスナーを追加
  const menuLinks = menu.querySelectorAll('a');
  menuLinks.forEach(link => {
    link.addEventListener('click', function() {
      toggleMenuState();
    });
  });

  // メニューの状態を切り替える関数
  function toggleMenuState() {
    toggleButton.classList.toggle('close');
    menu.classList.toggle('open');
  }
}